module.exports = __webpack_public_path__ + "img/logininfor.d9f91666.svg";